import { render, staticRenderFns } from "./WageSupplement.LumpSum.vue?vue&type=template&id=4b6339f7&scoped=true"
import script from "./WageSupplement.LumpSum.vue?vue&type=script&lang=js"
export * from "./WageSupplement.LumpSum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6339f7",
  null
  
)

export default component.exports